import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import * as getters from './getters'
import createMediaModule from './modules/mediaDefault'

Vue.use(Vuex)

export function createStore() {
    const store = new Vuex.Store({
        state: {
            appId: '',
            isAdmin: false,
            curRouteName: '',
            appFlag: 0
        },
        mutations,
        actions,
        getters,
        modules: {
            createMediaModule: createMediaModule()
        }
    })
    Vue.$store = store
    return store
}